<div class="desktop">
  <div class="header">
    <img class="logo" src="assets/images/builtup.svg" />
  </div>
  <div class="body">
    <form #novaSenhaForm="ngForm" class="form">
      <app-input
        type="password"
        width="100%"
        label="Nova senha"
        name="senha"
        placeholder="Digite a senha"
        [(ngModel)]="form.senha"
        (ngModelChange)="validatePassword()"
      ></app-input>
      <app-input
        type="password"
        width="100%"
        label="Repita a nova senha"
        name="novaSenha"
        placeholder="Digite a senha novamente"
        [(ngModel)]="form.novaSenha"
        (ngModelChange)="validatePassword()"
      ></app-input>
      <div class="validators">
        <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">
          <span *ngIf="isLengthValid; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          No mínimo 8 caracteres
        </p>
        <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
          <span *ngIf="hasNumber; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          Pelo menos um número
        </p>
        <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">
          <span *ngIf="hasLowercase; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          No mínimo 1 caractere minúsculo
        </p>
        <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">
          <span *ngIf="hasUppercase; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          No mínimo 1 caractere maiúsculo
        </p>
        <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
          <span *ngIf="hasSpecialChar; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          No mínimo 1 caractere especial
        </p>
        <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
          <span *ngIf="passwordsMatch; else crossIcon">✔️</span>
          <ng-template #crossIcon>❌</ng-template>
          As senhas devem ser iguais
        </p>
      </div>
      <app-botao
        width="100%"
        text="Definir senha"
        [disabled]="!isValid"
        (click)="definirNovaSenha()"
      ></app-botao>
    </form>
  </div>
</div>
